(() => {
  const TSHIRT_KEYWORDS = ['t-shirt', 't shirt', 'tshirt', 'tee'];
  const HOODIE_KEYWORDS = ['hoodie', 'hooded', 'kapuzenpullover', 'kapuzen-hoodie'];
  const BABY_BODY_KEYWORDS = ['babybody', 'baby body', 'body', 'onesie'];
  const MEN_SLIPPERS_KEYWORDS = ['herrenschlappen', 'herren-schlappen', 'herrenslides', 'men slippers', 'men slides'];
  const WOMEN_SLIPPERS_KEYWORDS = ['damenschlappen', 'damen-schlappen', 'womens slippers', 'women slippers', 'women slides'];
  const EMAILLE_TASSE_KEYWORDS = ['emailletasse', 'emaille tasse', 'emaille-becher', 'emaillebecher', 'mug', 'becher', 'tasse'];
  const GROSSER_BAUMWOLLBEUTEL_KEYWORDS = ['grosser bio-baumwollbeutel', 'großer bio-baumwollbeutel', 'grosser bio baumwollbeutel', 'großer bio baumwollbeutel'];
  const STOFFBEUTEL_KEYWORDS = ['bio-stoffbeutel', 'bio stoffbeutel', 'stoffbeutel'];
  const FAHNE_KEYWORDS = ['fahne', 'flagge', 'flag'];
  const POSTER_KEYWORDS = ['poster'];
  const SPIRAL_NOTEBOOK_KEYWORDS = ['spiral-notizblock', 'spiral notizblock', 'spiral-notebook', 'spiral notebook', 'notizblock', 'notizbuch', 'notebook'];
  const BUBBLE_FREE_STICKER_KEYWORDS = ['blasenfreie aufkleber', 'blasenfreier aufkleber', 'aufkleber', 'sticker', 'bubble-free sticker', 'bubble free sticker'];
  const PHONE_CASE_KEYWORDS = ['iphone', 'huelle', 'hülle', 'case', 'phone case', 'handyhuelle', 'handyhuelle'];
  const TOWEL_KEYWORDS = ['handtuch', 'towel'];
  const KIDS_CREWNECK_TSHIRT_KEYWORDS = [
    'rundhalsausschnitt',
    'crewneck',
    'kinder t-shirt',
    'kinder-t-shirt',
    'kinder tshirt',
    'kinder-tshirt',
    'kinder shirt',
    'kinder-shirt',
    'kindershirt',
    'kids t-shirt',
    'kids-t-shirt',
    'kids shirt',
    'kids-shirt'
  ];
  const YOUTH_CLASSIC_TSHIRT_KEYWORDS = ['jugendliche', 'youth'];
  const UNISEX_BAUMWOLL_TSHIRT_KEYWORDS = ['baumwoll', 'cotton'];
  const UNISEX_TSHIRT_KEYWORDS = ['unisex'];
  const UNISEX_HOODIE_KEYWORDS = ['unisex'];

  const TOWEL_LAYOUT = {
    x: 450,
    y: 350,
    width: 360,
    height: 360,
    rotationDeg: 1.2,
    designOpacity: 0.92,
    grainIntensity: 15,
    grainOpacity: 0.13
  };

  const SPIRAL_NOTEBOOK_LAYOUT = {
    x: 340,
    y: 270,
    width: 400,
    height: 400,
    designOpacity: 1
  };

  const PHONE_CASE_LAYOUT = {
    x: 560,
    y: 520,
    width: 480,
    height: 760,
    designOpacity: 1
  };

  const TSHIRT_LAYOUT = {
    centerX: 0.5,
    centerY: 0.40,
    widthRatio: 0.34,
    maxHeightRatio: 0.36
  };

  const HOODIE_LAYOUT = {
    centerX: 0.5,
    centerY: 0.40,
    widthRatio: 0.31,
    maxHeightRatio: 0.33
  };

  const UNISEX_TSHIRT_LAYOUT = {
    centerX: 0.5,
    centerY: 0.35,
    widthRatio: 0.40,
    maxHeightRatio: 0.40
  };

  const UNISEX_HOODIE_LAYOUT = {
    centerX: 0.5,
    centerY: 0.35,
    widthRatio: 0.35,
    maxHeightRatio: 0.35
  };

  const BABY_BODY_LAYOUT = {
    centerX: 0.5,
    centerY: 0.42,
    widthRatio: 0.38,
    maxHeightRatio: 0.38
  };

  const UNISEX_BAUMWOLL_TSHIRT_LAYOUT = {
    centerX: 0.5,
    centerY: 0.34,
    widthRatio: 0.36,
    maxHeightRatio: 0.34
  };

  const YOUTH_CLASSIC_TSHIRT_LAYOUT = {
    centerX: 0.5,
    centerY: 0.39,
    widthRatio: 0.36,
    maxHeightRatio: 0.34
  };

  const KIDS_CREWNECK_TSHIRT_LAYOUT = {
    centerX: 0.5,
    centerY: 0.39,
    widthRatio: 0.40,
    maxHeightRatio: 0.40
  };

  const ASSET_MAP = (() => {
    try {
      const el = document.getElementById('vs-mockup-assets');
      return el ? JSON.parse(el.textContent) : {};
    } catch {
      return {};
    }
  })();

  function toText(value) {
    return String(value || '').trim().toLowerCase();
  }

  function isUnisexTshirtProduct({ handle, title }) {
    const haystack = `${toText(handle)} ${toText(title)}`;
    return UNISEX_TSHIRT_KEYWORDS.some((word) => haystack.includes(word)) && isTshirtProduct({ handle, title });
  }

  function isUnisexHoodieProduct({ handle, title }) {
    const haystack = `${toText(handle)} ${toText(title)}`;
    return UNISEX_HOODIE_KEYWORDS.some((word) => haystack.includes(word)) && isHoodieProduct({ handle, title });
  }

  function isUnisexBaumwollTshirtProduct({ handle, title }) {
    const haystack = `${toText(handle)} ${toText(title)}`;
    return (
      haystack.includes('unisex') &&
      UNISEX_BAUMWOLL_TSHIRT_KEYWORDS.some((word) => haystack.includes(word)) &&
      isTshirtProduct({ handle, title })
    );
  }

  function isYouthClassicTshirtProduct({ handle, title }) {
    const haystack = `${toText(handle)} ${toText(title)}`;
    return YOUTH_CLASSIC_TSHIRT_KEYWORDS.some((word) => haystack.includes(word)) && isTshirtProduct({ handle, title });
  }

  function isKidsCrewneckTshirtProduct({ handle, title }) {
    const haystack = `${toText(handle)} ${toText(title)}`;
    const hasExplicitKidsShirtName = KIDS_CREWNECK_TSHIRT_KEYWORDS.some((word) => haystack.includes(word));
    const isTshirtForKids = (
      (haystack.includes('kinder') || haystack.includes('kids')) &&
      isTshirtProduct({ handle, title })
    );
    return hasExplicitKidsShirtName || isTshirtForKids;
  }

  function isBabyBodyProduct({ handle, title }) {
    const haystack = `${toText(handle)} ${toText(title)}`;
    return BABY_BODY_KEYWORDS.some((word) => haystack.includes(word));
  }

  function isMenSlippersProduct({ handle, title }) {
    const haystack = `${toText(handle)} ${toText(title)}`;
    return MEN_SLIPPERS_KEYWORDS.some((word) => haystack.includes(word));
  }

  function isWomenSlippersProduct({ handle, title }) {
    const haystack = `${toText(handle)} ${toText(title)}`;
    return WOMEN_SLIPPERS_KEYWORDS.some((word) => haystack.includes(word));
  }

  function isSlippersProduct({ handle, title }) {
    return isMenSlippersProduct({ handle, title }) || isWomenSlippersProduct({ handle, title });
  }

  function getSlippersBaseAssetKey({ handle, title, variantTitle, selectedSize, selectedColorHex }) {
    const haystack = [handle, title, variantTitle, selectedSize]
      .map(toText)
      .join(' ');
    const colorHex = toText(selectedColorHex).replace(/\s+/g, '');
    const usesWhiteBase = (
      /(?:^|[\s/_-])(white|weiss|weiß|natural|naturlich|natürlich)(?:$|[\s/_-])/.test(haystack) ||
      ['#fff', '#ffffff', '#f8eddc', '#f5e8ce'].includes(colorHex)
    );

    return usesWhiteBase ? 'slippers_white' : 'slippers_black';
  }

  function isEmailletasseProduct({ handle, title }) {
    const haystack = `${toText(handle)} ${toText(title)}`;
    return EMAILLE_TASSE_KEYWORDS.some((word) => haystack.includes(word));
  }

  function isGrosserBaumwollbeutelProduct({ handle, title }) {
    const haystack = `${toText(handle)} ${toText(title)}`;
    return GROSSER_BAUMWOLLBEUTEL_KEYWORDS.some((word) => haystack.includes(word));
  }

  function isStoffbeutelProduct({ handle, title }) {
    const haystack = `${toText(handle)} ${toText(title)}`;
    return STOFFBEUTEL_KEYWORDS.some((word) => haystack.includes(word));
  }

  function isFahneProduct({ handle, title }) {
    const haystack = `${toText(handle)} ${toText(title)}`;
    return FAHNE_KEYWORDS.some((word) => haystack.includes(word));
  }

  function isPosterProduct({ handle, title, variantTitle, selectedSize }) {
    const haystack = `${toText(handle)} ${toText(title)} ${toText(variantTitle)} ${toText(selectedSize)}`;
    return POSTER_KEYWORDS.some((word) => haystack.includes(word));
  }

  function isBubbleFreeStickerProduct({ handle, title }) {
    const haystack = `${toText(handle)} ${toText(title)}`;
    return BUBBLE_FREE_STICKER_KEYWORDS.some((word) => haystack.includes(word));
  }

  function isSpiralNotebookProduct({ handle, title }) {
    const haystack = `${toText(handle)} ${toText(title)}`;
    return SPIRAL_NOTEBOOK_KEYWORDS.some((word) => haystack.includes(word));
  }

  function isPhoneCaseProduct({ handle, title, variantTitle, selectedSize }) {
    const haystack = `${toText(handle)} ${toText(title)} ${toText(variantTitle)} ${toText(selectedSize)}`;
    const hasPhone = haystack.includes('iphone');
    const hasCaseWord = PHONE_CASE_KEYWORDS.some((word) => haystack.includes(word));
    return hasPhone && hasCaseWord;
  }

  function isTowelProduct({ handle, title }) {
    const haystack = `${toText(handle)} ${toText(title)}`;
    return TOWEL_KEYWORDS.some((word) => haystack.includes(word));
  }

  function isTshirtProduct({ handle, title }) {
    const haystack = `${toText(handle)} ${toText(title)}`;
    return TSHIRT_KEYWORDS.some((word) => haystack.includes(word));
  }

  function isHoodieProduct({ handle, title }) {
    const haystack = `${toText(handle)} ${toText(title)}`;
    return HOODIE_KEYWORDS.some((word) => haystack.includes(word));
  }

  function getProductLayout({ handle, title }) {
    if (isKidsCrewneckTshirtProduct({ handle, title })) return KIDS_CREWNECK_TSHIRT_LAYOUT;
    if (isYouthClassicTshirtProduct({ handle, title })) return YOUTH_CLASSIC_TSHIRT_LAYOUT;
    if (isUnisexBaumwollTshirtProduct({ handle, title })) return UNISEX_BAUMWOLL_TSHIRT_LAYOUT;
    if (isUnisexTshirtProduct({ handle, title })) return UNISEX_TSHIRT_LAYOUT;
    if (isUnisexHoodieProduct({ handle, title })) return UNISEX_HOODIE_LAYOUT;
    if (isBabyBodyProduct({ handle, title })) return BABY_BODY_LAYOUT;
    if (isTshirtProduct({ handle, title })) return TSHIRT_LAYOUT;
    if (isHoodieProduct({ handle, title })) return HOODIE_LAYOUT;
    return null;
  }

  function getBaseAssetKey({ handle, title }) {
    if (isTowelProduct({ handle, title })) return 'towel_base';
    if (isKidsCrewneckTshirtProduct({ handle, title })) return 'kids_crewneck_tshirt';
    if (isYouthClassicTshirtProduct({ handle, title })) return 'youth_classic_tshirt';
    if (isUnisexBaumwollTshirtProduct({ handle, title })) return 'unisex_baumwoll_tshirt';
    if (isUnisexTshirtProduct({ handle, title })) return 'unisex_tshirt';
    if (isUnisexHoodieProduct({ handle, title })) return 'unisex_hoodie';
    if (isBabyBodyProduct({ handle, title })) return 'baby_body';
    return null;
  }

  function getOrCreateColorLayer(previewEl) {
    if (!previewEl) return null;

    let layerEl = previewEl.querySelector('.vs-preview-color-layer');
    if (!layerEl) {
      layerEl = document.createElement('div');
      layerEl.className = 'vs-preview-color-layer';
      layerEl.style.position = 'absolute';
      layerEl.style.left = '0';
      layerEl.style.top = '0';
      layerEl.style.width = '0';
      layerEl.style.height = '0';
      layerEl.style.display = 'none';
      layerEl.style.zIndex = '1';
      previewEl.insertBefore(layerEl, previewEl.firstChild);
    }

    return layerEl;
  }

  function getOrCreateCompositeCanvas(previewEl) {
    if (!previewEl) return null;

    let canvasEl = previewEl.querySelector('.vs-preview-composite-canvas');
    if (!canvasEl) {
      canvasEl = document.createElement('canvas');
      canvasEl.className = 'vs-preview-composite-canvas';
      canvasEl.style.display = 'none';
      canvasEl.style.position = 'relative';
      canvasEl.style.zIndex = '3';
      canvasEl.style.width = '100%';
      canvasEl.style.height = 'auto';
      canvasEl.style.maxWidth = '100%';
      canvasEl.style.maxHeight = '100%';
      canvasEl.style.objectFit = 'contain';
      canvasEl.style.borderRadius = '20px';
      const placeholderEl = previewEl.querySelector(
        '#vs-preview-placeholder, [data-vsp-modal-placeholder], [data-vanscape-cart-preview-placeholder]'
      );
      previewEl.insertBefore(canvasEl, placeholderEl || null);
    }

    return canvasEl;
  }

  function showCompositeCanvas({ previewEl, imgEl, overlayEl, canvasEl, placeholderEl }) {
    if (!previewEl || !imgEl || !canvasEl || !placeholderEl) return false;

    // A canvas mockup is already the complete product image. Leaving the old
    // DOM color/overlay layers in place caused colored side bars after a
    // resize and a loose design thumbnail inside the cart drawer.
    previewEl.querySelectorAll('.vs-preview-color-layer').forEach((layerEl) => layerEl.remove());

    if (overlayEl) {
      overlayEl.style.setProperty('display', 'none', 'important');
      overlayEl.removeAttribute('src');
    }

    imgEl.style.setProperty('display', 'none', 'important');
    imgEl.removeAttribute('src');

    canvasEl.style.setProperty('display', 'block', 'important');
    canvasEl.style.setProperty('width', '100%', 'important');
    canvasEl.style.setProperty('height', 'auto', 'important');
    canvasEl.style.setProperty('max-width', '100%', 'important');
    canvasEl.style.setProperty('max-height', '100%', 'important');
    placeholderEl.style.display = 'none';
    previewEl.classList.add('vs-preview--canvas');
    return true;
  }

  function getBaseLayerColor({ handle, title, selectedColorHex }) {
    return selectedColorHex || '#d1d5db';
  }

  function applyColorLayerFrame(colorLayerEl, {
    left = '0px',
    top = '0px',
    width = '0px',
    height = '0px'
  } = {}) {
    if (!colorLayerEl) return;

    const display = colorLayerEl.style.display || 'none';
    const backgroundColor = colorLayerEl.style.backgroundColor || 'transparent';
    colorLayerEl.style.cssText = [
      'position:absolute',
      `left:${left}`,
      `top:${top}`,
      `width:${width}`,
      `height:${height}`,
      `display:${display}`,
      'z-index:1',
      `background-color:${backgroundColor}`
    ].join(';');
  }

  async function loadDisplayImage(src) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = () => reject(new Error(`Bild konnte nicht geladen werden: ${src}`));
      img.src = src;
    });
  }

  async function loadImageElement(imgEl, src) {
    await new Promise((resolve, reject) => {
      let settled = false;

      const cleanup = () => {
        imgEl.removeEventListener('load', onLoad);
        imgEl.removeEventListener('error', onError);
      };
      const finish = (callback) => {
        if (settled) return;
        settled = true;
        cleanup();
        callback();
      };
      const onLoad = () => finish(resolve);
      const onError = () => finish(() => reject(new Error(`Bild konnte nicht geladen werden: ${src}`)));

      imgEl.addEventListener('load', onLoad);
      imgEl.addEventListener('error', onError);
      imgEl.src = src;

      if (imgEl.complete) {
        queueMicrotask(() => {
          if (imgEl.naturalWidth > 0) onLoad();
          else onError();
        });
      }
    });

    await new Promise((resolve) => requestAnimationFrame(resolve));
  }

  function createMaskedGrainCanvas(sourceCanvas, intensity) {
    const grainCanvas = document.createElement('canvas');
    const grainCtx = grainCanvas.getContext('2d');
    const width = sourceCanvas.width;
    const height = sourceCanvas.height;

    grainCanvas.width = width;
    grainCanvas.height = height;

    for (let y = 0; y < height; y += 2) {
      for (let x = 0; x < width; x += 2) {
        const noise = Math.floor(128 + (Math.random() - 0.5) * intensity * 10);
        grainCtx.fillStyle = `rgb(${noise}, ${noise}, ${noise})`;
        grainCtx.fillRect(x, y, 2, 2);
      }
    }

    grainCtx.globalCompositeOperation = 'destination-in';
    grainCtx.drawImage(sourceCanvas, 0, 0);

    return grainCanvas;
  }

  async function renderTowelMockupToCanvas({ canvasEl, baseSrc, designSrc, backgroundSrc }) {
    const [baseImage, designImage, backgroundImage] = await Promise.all([
      loadDisplayImage(baseSrc),
      loadDisplayImage(designSrc),
      loadDisplayImage(backgroundSrc)
    ]);

    const towelCanvas = document.createElement('canvas');
    const towelCtx = towelCanvas.getContext('2d');
    towelCanvas.width = baseImage.width;
    towelCanvas.height = baseImage.height;
    towelCtx.drawImage(baseImage, 0, 0);

    const rotationInRadians = (TOWEL_LAYOUT.rotationDeg * Math.PI) / 180;
    const centerX = TOWEL_LAYOUT.x + (TOWEL_LAYOUT.width / 2);
    const centerY = TOWEL_LAYOUT.y + (TOWEL_LAYOUT.height / 2);

    towelCtx.save();
    towelCtx.translate(centerX, centerY);
    towelCtx.rotate(rotationInRadians);
    towelCtx.globalAlpha = TOWEL_LAYOUT.designOpacity;
    towelCtx.drawImage(
      designImage,
      -TOWEL_LAYOUT.width / 2,
      -TOWEL_LAYOUT.height / 2,
      TOWEL_LAYOUT.width,
      TOWEL_LAYOUT.height
    );
    towelCtx.restore();

    const grainCanvas = createMaskedGrainCanvas(towelCanvas, TOWEL_LAYOUT.grainIntensity);
    towelCtx.save();
    towelCtx.globalAlpha = TOWEL_LAYOUT.grainOpacity;
    towelCtx.drawImage(grainCanvas, 0, 0);
    towelCtx.restore();

    const finalCtx = canvasEl.getContext('2d');
    canvasEl.width = backgroundImage.width;
    canvasEl.height = backgroundImage.height;
    finalCtx.clearRect(0, 0, canvasEl.width, canvasEl.height);
    finalCtx.drawImage(backgroundImage, 0, 0);
    finalCtx.drawImage(towelCanvas, 0, 0);
  }

  async function renderSimplePlacedDesignMockupToCanvas({
    canvasEl,
    baseSrc,
    designSrc,
    placement
  }) {
    const [baseImage, designImage] = await Promise.all([
      loadDisplayImage(baseSrc),
      loadDisplayImage(designSrc)
    ]);

    const finalCtx = canvasEl.getContext('2d');
    canvasEl.width = baseImage.width;
    canvasEl.height = baseImage.height;
    finalCtx.clearRect(0, 0, canvasEl.width, canvasEl.height);
    finalCtx.drawImage(baseImage, 0, 0);

    finalCtx.save();
    finalCtx.globalAlpha = placement.designOpacity ?? 1;
    drawImageContained(
      finalCtx,
      designImage,
      placement.x,
      placement.y,
      placement.width,
      placement.height
    );
    finalCtx.restore();
  }

  async function renderStandaloneDesignPreviewToCanvas({ canvasEl, designSrc }) {
    const designImage = await loadDisplayImage(designSrc);
    const size = 1024;
    const padding = 140;
    const finalCtx = canvasEl.getContext('2d');

    canvasEl.width = size;
    canvasEl.height = size;
    finalCtx.clearRect(0, 0, size, size);
    finalCtx.fillStyle = '#ffffff';
    finalCtx.fillRect(0, 0, size, size);

    finalCtx.save();
    finalCtx.shadowColor = 'rgba(0, 0, 0, 0.14)';
    finalCtx.shadowBlur = 18;
    finalCtx.shadowOffsetY = 8;
    drawImageContained(
      finalCtx,
      designImage,
      padding,
      padding,
      size - (padding * 2),
      size - (padding * 2)
    );
    finalCtx.restore();
  }

  function drawImageContained(ctx, image, x, y, width, height) {
    const imageWidth = image.naturalWidth || image.width;
    const imageHeight = image.naturalHeight || image.height;
    if (!imageWidth || !imageHeight || !width || !height) return;

    const scale = Math.min(width / imageWidth, height / imageHeight);
    const renderedWidth = imageWidth * scale;
    const renderedHeight = imageHeight * scale;
    const renderedX = x + ((width - renderedWidth) / 2);
    const renderedY = y + ((height - renderedHeight) / 2);

    ctx.drawImage(image, renderedX, renderedY, renderedWidth, renderedHeight);
  }

  async function renderColoredGarmentMockupToCanvas({
    canvasEl,
    baseSrc,
    designSrc,
    color,
    layout
  }) {
    const [baseImage, designImage] = await Promise.all([
      loadDisplayImage(baseSrc),
      loadDisplayImage(designSrc)
    ]);

    const width = baseImage.naturalWidth || baseImage.width;
    const height = baseImage.naturalHeight || baseImage.height;
    const finalCtx = canvasEl.getContext('2d');

    canvasEl.width = width;
    canvasEl.height = height;
    finalCtx.clearRect(0, 0, width, height);

    // The garment base is deliberately semi-transparent over the fabric and
    // opaque around it. Drawing the color first therefore tints only the
    // garment, while the opaque background keeps the mockup white.
    finalCtx.fillStyle = color || '#d1d5db';
    finalCtx.fillRect(0, 0, width, height);

    const designBoxWidth = width * layout.widthRatio;
    const designBoxHeight = height * layout.maxHeightRatio;
    const designBoxX = (width * layout.centerX) - (designBoxWidth / 2);
    const designBoxY = (height * layout.centerY) - (designBoxHeight / 2);
    drawImageContained(
      finalCtx,
      designImage,
      designBoxX,
      designBoxY,
      designBoxWidth,
      designBoxHeight
    );

    // Draw the fabric texture and shadows over both color and design, matching
    // the former DOM layer order without relying on measured element sizes.
    finalCtx.drawImage(baseImage, 0, 0, width, height);
  }

  function positionColorLayer({ imgEl, colorLayerEl }) {
    const previewEl = imgEl?.parentElement;
    if (!previewEl || !imgEl || !colorLayerEl) return;
    if (imgEl.style.display === 'none') return;

    const previewRect = previewEl.getBoundingClientRect();
    const productRect = imgEl.getBoundingClientRect();
    if (!productRect.width || !productRect.height) return;

    applyColorLayerFrame(colorLayerEl, {
      left: `${productRect.left - previewRect.left}px`,
      top: `${productRect.top - previewRect.top}px`,
      width: `${productRect.width}px`,
      height: `${productRect.height}px`
    });
  }

  function ensurePreviewResizeObserver(imgEl) {
    if (!imgEl || imgEl.__vsPreviewResizeObserver || typeof ResizeObserver !== 'function') return;

    const observer = new ResizeObserver(() => {
      if (!imgEl.isConnected) {
        observer.disconnect();
        imgEl.__vsPreviewResizeObserver = null;
        return;
      }

      imgEl.__vsColorLayerUpdate?.();
      imgEl.__vsOverlayUpdate?.();
    });

    observer.observe(imgEl);
    if (imgEl.parentElement) observer.observe(imgEl.parentElement);
    imgEl.__vsPreviewResizeObserver = observer;
  }

  function ensureColorLayerAutoPosition({ imgEl, colorLayerEl }) {
    if (!imgEl || !colorLayerEl) return;

    if (!imgEl.__vsColorLayerBound) {
      const onUpdate = () => positionColorLayer({ imgEl, colorLayerEl });
      imgEl.__vsColorLayerUpdate = onUpdate;
      imgEl.addEventListener('load', onUpdate);
      window.addEventListener('resize', onUpdate);
      imgEl.__vsColorLayerBound = true;
    }

    ensurePreviewResizeObserver(imgEl);
    positionColorLayer({ imgEl, colorLayerEl });
  }

  function getOverlay(imgEl) {
    const previewEl = imgEl?.parentElement;
    if (!previewEl) return null;
    return previewEl.querySelector('#vs-design-overlay, .vs-design-overlay');
  }

  function positionOverlay({ imgEl, overlayEl, layout }) {
    const previewEl = imgEl.parentElement;
    if (!previewEl || !imgEl || !overlayEl) return;
    if (imgEl.style.display === 'none') return;

    const previewRect = previewEl.getBoundingClientRect();
    const productRect = imgEl.getBoundingClientRect();
    if (!productRect.width || !productRect.height) return;

    const width = productRect.width * layout.widthRatio;
    const height = productRect.height * layout.maxHeightRatio;
    const left = (productRect.left - previewRect.left) + (productRect.width * layout.centerX) - (width / 2);
    const top = (productRect.top - previewRect.top) + (productRect.height * layout.centerY) - (height / 2);

    overlayEl.style.left = `${left}px`;
    overlayEl.style.top = `${top}px`;
    overlayEl.style.width = `${width}px`;
    overlayEl.style.height = `${height}px`;
  }

  function ensureOverlayAutoPosition({ imgEl, overlayEl, layout }) {
    if (!imgEl || !overlayEl) return;
    imgEl.__vsOverlayLayout = layout;

    if (!imgEl.__vsOverlayBound) {
      const onUpdate = () => positionOverlay({
        imgEl,
        overlayEl,
        layout: imgEl.__vsOverlayLayout || layout
      });
      imgEl.__vsOverlayUpdate = onUpdate;
      imgEl.addEventListener('load', onUpdate);
      window.addEventListener('resize', onUpdate);
      imgEl.__vsOverlayBound = true;
    }

    ensurePreviewResizeObserver(imgEl);
    positionOverlay({ imgEl, overlayEl, layout });
  }

  function clearProductPreviewOverlay({ imgEl, placeholderEl }) {
    if (!imgEl) return;
    const previewEl = imgEl.parentElement;
    const overlayEl = previewEl?.querySelector('.vs-design-overlay');
    const colorLayerEl = previewEl?.querySelector('.vs-preview-color-layer');
    const compositeCanvasEl = previewEl?.querySelector('.vs-preview-composite-canvas');
    if (overlayEl) {
      overlayEl.style.display = 'none';
      overlayEl.removeAttribute('src');
    }
    if (colorLayerEl) {
      colorLayerEl.remove();
    }
    if (compositeCanvasEl) {
      const ctx = compositeCanvasEl.getContext('2d');
      ctx?.clearRect(0, 0, compositeCanvasEl.width, compositeCanvasEl.height);
      compositeCanvasEl.style.removeProperty('display');
      compositeCanvasEl.style.display = 'none';
      compositeCanvasEl.width = 0;
      compositeCanvasEl.height = 0;
    }
    previewEl?.classList.remove('vs-preview--canvas');
    if (placeholderEl && placeholderEl.style.display !== 'none' && imgEl.style.display === 'none') {
      placeholderEl.style.display = 'block';
    }
  }

  async function renderProductPreview({
    productHandle,
    productTitle,
    variantTitle,
    selectedSize,
    productImageUrl,
    designThumbUrl,
    selectedColorHex,
    imgEl,
    placeholderEl
  }) {
    if (!imgEl || !placeholderEl) return false;
    if (!designThumbUrl) return false;

    const previewEl = imgEl.parentElement;
    previewEl?.querySelectorAll('.vs-preview-color-layer').forEach((layerEl) => layerEl.remove());
    // Canvas branches do not need the legacy color layer. Create it only for
    // the last-resort DOM overlay path at the end of this function.
    let colorLayerEl = null;
    const overlayEl = getOverlay(imgEl);
    const compositeCanvasEl = getOrCreateCompositeCanvas(previewEl);

    if (isSlippersProduct({ handle: productHandle, title: productTitle })) {
      const slippersBaseSrc = ASSET_MAP[getSlippersBaseAssetKey({
        handle: productHandle,
        title: productTitle,
        variantTitle,
        selectedSize,
        selectedColorHex
      })];
      if (!slippersBaseSrc || !compositeCanvasEl || !window.VanscapeSlippersMockup?.renderToCanvas) {
        return false;
      }

      await window.VanscapeSlippersMockup.renderToCanvas({
        canvasEl: compositeCanvasEl,
        baseSrc: slippersBaseSrc,
        designSrc: designThumbUrl,
        config: window.VanscapeSlippersMockup.defaultConfig
      });

      if (colorLayerEl) {
        colorLayerEl.style.display = 'none';
        colorLayerEl.style.backgroundColor = 'transparent';
        applyColorLayerFrame(colorLayerEl);
      }

      overlayEl.style.display = 'none';
      overlayEl.removeAttribute('src');
      imgEl.style.display = 'none';
      imgEl.removeAttribute('src');
      compositeCanvasEl.style.display = 'block';
      placeholderEl.style.display = 'none';
      return true;
    }

    if (isEmailletasseProduct({ handle: productHandle, title: productTitle })) {
      const mugBaseSrc = ASSET_MAP.emaille_mug;
      if (!mugBaseSrc || !compositeCanvasEl || !window.VanscapeEmailletasseMockup?.renderToCanvas) {
        return false;
      }

      await window.VanscapeEmailletasseMockup.renderToCanvas({
        canvasEl: compositeCanvasEl,
        baseSrc: mugBaseSrc,
        designSrc: designThumbUrl,
        config: window.VanscapeEmailletasseMockup.defaultConfig
      });

      if (colorLayerEl) {
        colorLayerEl.style.display = 'none';
        colorLayerEl.style.backgroundColor = 'transparent';
        applyColorLayerFrame(colorLayerEl);
      }

      overlayEl.style.display = 'none';
      overlayEl.removeAttribute('src');
      imgEl.style.display = 'none';
      imgEl.removeAttribute('src');
      compositeCanvasEl.style.display = 'block';
      placeholderEl.style.display = 'none';
      return true;
    }

    if (isGrosserBaumwollbeutelProduct({ handle: productHandle, title: productTitle })) {
      const bagBaseSrc = ASSET_MAP.large_cotton_bag;
      if (!bagBaseSrc || !compositeCanvasEl || !window.VanscapeGrosserBaumwollbeutelMockup?.renderToCanvas) {
        return false;
      }

      await window.VanscapeGrosserBaumwollbeutelMockup.renderToCanvas({
        canvasEl: compositeCanvasEl,
        baseSrc: bagBaseSrc,
        designSrc: designThumbUrl,
        config: window.VanscapeGrosserBaumwollbeutelMockup.defaultConfig
      });

      if (colorLayerEl) {
        colorLayerEl.style.display = 'none';
        colorLayerEl.style.backgroundColor = 'transparent';
        applyColorLayerFrame(colorLayerEl);
      }

      overlayEl.style.display = 'none';
      overlayEl.removeAttribute('src');
      imgEl.style.display = 'none';
      imgEl.removeAttribute('src');
      compositeCanvasEl.style.display = 'block';
      placeholderEl.style.display = 'none';
      return true;
    }

    if (isStoffbeutelProduct({ handle: productHandle, title: productTitle })) {
      const bagBaseSrc = ASSET_MAP.tote_bag;
      if (!bagBaseSrc || !compositeCanvasEl || !window.VanscapeStoffbeutelMockup?.renderToCanvas) {
        return false;
      }

      await window.VanscapeStoffbeutelMockup.renderToCanvas({
        canvasEl: compositeCanvasEl,
        baseSrc: bagBaseSrc,
        designSrc: designThumbUrl,
        config: window.VanscapeStoffbeutelMockup.defaultConfig
      });

      if (colorLayerEl) {
        colorLayerEl.style.display = 'none';
        colorLayerEl.style.backgroundColor = 'transparent';
        applyColorLayerFrame(colorLayerEl);
      }

      overlayEl.style.display = 'none';
      overlayEl.removeAttribute('src');
      imgEl.style.display = 'none';
      imgEl.removeAttribute('src');
      compositeCanvasEl.style.display = 'block';
      placeholderEl.style.display = 'none';
      return true;
    }

    if (isFahneProduct({ handle: productHandle, title: productTitle })) {
      const flagBaseSrc = ASSET_MAP.flag;
      if (!flagBaseSrc || !compositeCanvasEl || !window.VanscapeFahneMockup?.renderToCanvas) {
        return false;
      }

      await window.VanscapeFahneMockup.renderToCanvas({
        canvasEl: compositeCanvasEl,
        baseSrc: flagBaseSrc,
        designSrc: designThumbUrl,
        config: window.VanscapeFahneMockup.defaultConfig
      });

      if (colorLayerEl) {
        colorLayerEl.style.display = 'none';
        colorLayerEl.style.backgroundColor = 'transparent';
        applyColorLayerFrame(colorLayerEl);
      }

      overlayEl.style.display = 'none';
      overlayEl.removeAttribute('src');
      imgEl.style.display = 'none';
      imgEl.removeAttribute('src');
      compositeCanvasEl.style.display = 'block';
      placeholderEl.style.display = 'none';
      return true;
    }

    if (isPosterProduct({ handle: productHandle, title: productTitle, variantTitle, selectedSize })) {
      const posterBaseSrc = ASSET_MAP.poster;
      const posterPlacement = window.VanscapePosterMockup?.getPlacementForVariant(
        selectedSize,
        variantTitle,
        productTitle,
        productHandle
      );
      if (!posterBaseSrc || !compositeCanvasEl || !posterPlacement) return false;

      await renderSimplePlacedDesignMockupToCanvas({
        canvasEl: compositeCanvasEl,
        baseSrc: posterBaseSrc,
        designSrc: designThumbUrl,
        placement: posterPlacement
      });

      if (colorLayerEl) {
        colorLayerEl.style.display = 'none';
        colorLayerEl.style.backgroundColor = 'transparent';
        applyColorLayerFrame(colorLayerEl);
      }

      overlayEl.style.display = 'none';
      overlayEl.removeAttribute('src');
      imgEl.style.display = 'none';
      imgEl.removeAttribute('src');
      compositeCanvasEl.style.display = 'block';
      placeholderEl.style.display = 'none';
      return true;
    }

    if (isTowelProduct({ handle: productHandle, title: productTitle })) {
      const towelBaseSrc = ASSET_MAP.towel_base;
      const towelBackgroundSrc = ASSET_MAP.towel_background;
      if (!towelBaseSrc || !towelBackgroundSrc || !compositeCanvasEl) return false;

      await renderTowelMockupToCanvas({
        canvasEl: compositeCanvasEl,
        baseSrc: towelBaseSrc,
        designSrc: designThumbUrl,
        backgroundSrc: towelBackgroundSrc
      });

      if (colorLayerEl) {
        colorLayerEl.style.display = 'none';
        colorLayerEl.style.backgroundColor = 'transparent';
        applyColorLayerFrame(colorLayerEl);
      }

      overlayEl.style.display = 'none';
      overlayEl.removeAttribute('src');

      imgEl.style.display = 'none';
      imgEl.removeAttribute('src');
      compositeCanvasEl.style.display = 'block';
      placeholderEl.style.display = 'none';
      return true;
    }

    if (isSpiralNotebookProduct({ handle: productHandle, title: productTitle })) {
      const notebookBaseSrc = ASSET_MAP.spiral_notebook;
      if (!notebookBaseSrc || !compositeCanvasEl) return false;

      await renderSimplePlacedDesignMockupToCanvas({
        canvasEl: compositeCanvasEl,
        baseSrc: notebookBaseSrc,
        designSrc: designThumbUrl,
        placement: SPIRAL_NOTEBOOK_LAYOUT
      });

      if (colorLayerEl) {
        colorLayerEl.style.display = 'none';
        colorLayerEl.style.backgroundColor = 'transparent';
        applyColorLayerFrame(colorLayerEl);
      }

      overlayEl.style.display = 'none';
      overlayEl.removeAttribute('src');
      imgEl.style.display = 'none';
      imgEl.removeAttribute('src');
      compositeCanvasEl.style.display = 'block';
      placeholderEl.style.display = 'none';
      return true;
    }

    if (isBubbleFreeStickerProduct({ handle: productHandle, title: productTitle })) {
      if (!compositeCanvasEl) return false;

      await renderStandaloneDesignPreviewToCanvas({
        canvasEl: compositeCanvasEl,
        designSrc: designThumbUrl
      });

      if (colorLayerEl) {
        colorLayerEl.style.display = 'none';
        colorLayerEl.style.backgroundColor = 'transparent';
        applyColorLayerFrame(colorLayerEl);
      }

      overlayEl.style.display = 'none';
      overlayEl.removeAttribute('src');
      imgEl.style.display = 'none';
      imgEl.removeAttribute('src');
      compositeCanvasEl.style.display = 'block';
      placeholderEl.style.display = 'none';
      return true;
    }

    if (isPhoneCaseProduct({ handle: productHandle, title: productTitle, variantTitle, selectedSize })) {
      const phoneBaseSrc = ASSET_MAP.phone_case;
      if (!phoneBaseSrc || !compositeCanvasEl) return false;

      await renderSimplePlacedDesignMockupToCanvas({
        canvasEl: compositeCanvasEl,
        baseSrc: phoneBaseSrc,
        designSrc: designThumbUrl,
        placement: PHONE_CASE_LAYOUT
      });

      if (colorLayerEl) {
        colorLayerEl.style.display = 'none';
        colorLayerEl.style.backgroundColor = 'transparent';
        applyColorLayerFrame(colorLayerEl);
      }

      overlayEl.style.display = 'none';
      overlayEl.removeAttribute('src');
      imgEl.style.display = 'none';
      imgEl.removeAttribute('src');
      compositeCanvasEl.style.display = 'block';
      placeholderEl.style.display = 'none';
      return true;
    }

    if (compositeCanvasEl) {
      const ctx = compositeCanvasEl.getContext('2d');
      ctx?.clearRect(0, 0, compositeCanvasEl.width, compositeCanvasEl.height);
      compositeCanvasEl.style.display = 'none';
      compositeCanvasEl.width = 0;
      compositeCanvasEl.height = 0;
    }

    const layout = getProductLayout({ handle: productHandle, title: productTitle });
    if (!layout) return false;

    const baseAssetKey = getBaseAssetKey({ handle: productHandle, title: productTitle });
    const usesBaseAssetMockup = Boolean(baseAssetKey);
    const baseImageUrl = usesBaseAssetMockup ? ASSET_MAP[baseAssetKey] : productImageUrl;
    if (!baseImageUrl) return false;

    if (usesBaseAssetMockup && compositeCanvasEl) {
      await renderColoredGarmentMockupToCanvas({
        canvasEl: compositeCanvasEl,
        baseSrc: baseImageUrl,
        designSrc: designThumbUrl,
        color: getBaseLayerColor({
          handle: productHandle,
          title: productTitle,
          selectedColorHex
        }),
        layout
      });

      return showCompositeCanvas({
        previewEl,
        imgEl,
        overlayEl,
        canvasEl: compositeCanvasEl,
        placeholderEl
      });
    }

    if (!overlayEl) return false;
    colorLayerEl = getOrCreateColorLayer(previewEl);

    if (usesBaseAssetMockup && colorLayerEl) {
      colorLayerEl.style.backgroundColor = getBaseLayerColor({
        handle: productHandle,
        title: productTitle,
        selectedColorHex
      });
      colorLayerEl.style.display = 'block';
    } else if (colorLayerEl) {
      colorLayerEl.style.display = 'none';
      colorLayerEl.style.backgroundColor = 'transparent';
      applyColorLayerFrame(colorLayerEl);
    }

    imgEl.style.display = 'block';
    imgEl.style.position = 'relative';
    imgEl.style.zIndex = '3';
    placeholderEl.style.display = 'none';
    await loadImageElement(imgEl, baseImageUrl);

    if (usesBaseAssetMockup && colorLayerEl) {
      ensureColorLayerAutoPosition({ imgEl, colorLayerEl });
    }

    overlayEl.src = designThumbUrl;
    overlayEl.style.position = 'absolute';
    overlayEl.style.pointerEvents = 'none';
    overlayEl.style.objectFit = 'contain';
    overlayEl.style.zIndex = usesBaseAssetMockup ? '2' : '3';
    overlayEl.style.display = 'block';
    ensureOverlayAutoPosition({ imgEl, overlayEl, layout });

    return true;
  }

  window.VanscapeMockupGenerator = {
    isSlippersProduct,
    isMenSlippersProduct,
    isWomenSlippersProduct,
    isEmailletasseProduct,
    isGrosserBaumwollbeutelProduct,
    isStoffbeutelProduct,
    isFahneProduct,
    isPosterProduct,
    isSpiralNotebookProduct,
    isBubbleFreeStickerProduct,
    isPhoneCaseProduct,
    isTowelProduct,
    isKidsCrewneckTshirtProduct,
    isYouthClassicTshirtProduct,
    isUnisexBaumwollTshirtProduct,
    isUnisexTshirtProduct,
    isUnisexHoodieProduct,
    isBabyBodyProduct,
    isTshirtProduct,
    isHoodieProduct,
    renderProductPreview,
    clearProductPreviewOverlay
  };
})();
